import { CorporateSummaryData } from '@/api/corporate/corporate.types.ts';
import { PaginatedApiResponse } from '@/api/shared.types.ts';
import axiosServer from '@/services/axios.ts';
import { transformToApiError } from '@/utils/error.ts';

const endpoint = '/corporate';

export const getAllCorporateUsers = async (
  page: number,
  pageSize: number
): Promise<PaginatedApiResponse<CorporateSummaryData>> => {
  try {
    const params: Record<string, any> = { page, pageSize };
    const response = await axiosServer.get(`${endpoint}/stats`, { params });
    return response.data;
  } catch (error) {
    return transformToApiError(error);
  }
};
